import { HIDE_CONFIRM_DIALOG } from 'src/vuex/modules/confirm-dialog/types.js'
import {
  NOTIFY_ERROR,
  NOTIFY_SUCCESS
} from 'src/vuex/modules/snackbar/types.js'
import {
  acceptETPSettlements,
  acceptETRSettlement,
  getPendingETPSettlements,
  getPendingETRSettlements,
  rejectETPSettlements,
  rejectETRSettlement
} from '../apiCalls.js'
import texts from '../assets/texts.json'
import * as types from './types.js'

export default {
  [types.UPDATE_PAGINATION]({ state, commit, dispatch }, pagination) {
    commit(types.SET_PAGINATION, pagination)
    dispatch(types[`GET_PENDING_${state.selectedProduct}_SETTLEMENTS`])
  },
  [types.GET_PENDING_ETR_SETTLEMENTS]: async ({ commit, dispatch, state }) => {
    commit(types.SET_LOADING, true)
    try {
      const resp = await getPendingETRSettlements(state.pagination['ETR'])
      resp.product = 'ETR'

      commit(types.SET_PENDING_SETTLEMENTS_RESPONSE, resp)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
    commit(types.SET_LOADING, false)
  },
  [types.GET_PENDING_ETP_SETTLEMENTS]: async ({ commit, dispatch, state }) => {
    commit(types.SET_LOADING, true)
    try {
      const resp = await getPendingETPSettlements(state.pagination['ETP'])
      resp.product = 'ETP'

      commit(types.SET_PENDING_SETTLEMENTS_RESPONSE, resp)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
    commit(types.SET_LOADING, false)
  },
  [types.GET_PENDING_SETTLEMENTS]: async ({ dispatch, state }) => {
    state.availableProducts.forEach((product) => {
      dispatch(types[`GET_PENDING_${product}_SETTLEMENTS`])
    })
  },
  [types.APPROVE_ETR_SETTLEMENT]: async ({ commit, dispatch }, payload) => {
    commit(types.SET_LOADING, true)
    try {
      await acceptETRSettlement(payload.id, payload.invoice_id)

      dispatch(NOTIFY_SUCCESS, {
        message: texts.NOTIFICATIONS.acceptSuccessMessage
      })
      dispatch(types.GET_PENDING_ETR_SETTLEMENTS)
    } catch (err) {
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
    commit(types.SET_LOADING, false)
    commit(HIDE_CONFIRM_DIALOG)
  },
  [types.BULK_APPROVE_ETR_SETTLEMENT]: ({ commit, dispatch }, settlements) => {
    commit(types.SET_LOADING, true)
    try {
      settlements.forEach(async (settlement) => {
        await acceptETRSettlement(settlement.id, settlement.invoice_id)
      })

      commit(types.SET_SELECTED_SETTLEMENTS, [])
      dispatch(NOTIFY_SUCCESS, {
        message: texts.NOTIFICATIONS.acceptSuccessMessage
      })
    } catch (err) {
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
    commit(types.SET_LOADING, false)
    commit(HIDE_CONFIRM_DIALOG)
    dispatch(types.GET_PENDING_ETR_SETTLEMENTS)
  },
  [types.REJECT_ETR_SETTLEMENT]: async ({ commit, dispatch }, payload) => {
    commit(types.SET_LOADING, true)
    try {
      await rejectETRSettlement(
        payload.id,
        payload.invoice_id,
        payload.settle_amount
      )

      dispatch(NOTIFY_SUCCESS, {
        message: texts.NOTIFICATIONS.acceptSuccessMessage
      })
      dispatch(types.GET_PENDING_ETR_SETTLEMENTS)
    } catch (err) {
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
    commit(types.SET_LOADING, false)
    commit(HIDE_CONFIRM_DIALOG)
  },
  [types.BULK_REJECT_ETR_SETTLEMENT]: ({ commit, dispatch }, settlements) => {
    commit(types.SET_LOADING, true)
    try {
      settlements.forEach(async (settlement) => {
        await rejectETRSettlement(
          settlement.id,
          settlement.invoice_id,
          settlement.settle_amount
        )
      })

      commit(types.SET_SELECTED_SETTLEMENTS, [])
      dispatch(NOTIFY_SUCCESS, {
        message: texts.NOTIFICATIONS.rejectSuccessMessage
      })
    } catch (err) {
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
    commit(types.SET_LOADING, false)
    commit(HIDE_CONFIRM_DIALOG)
    dispatch(types.GET_PENDING_ETR_SETTLEMENTS)
  },
  [types.ACCEPT_ETP_SETTLEMENTS]: async ({ commit, dispatch }, { etpIds }) => {
    commit(types.SET_LOADING, true)

    try {
      await acceptETPSettlements(etpIds)

      commit(types.SET_SELECTED_SETTLEMENTS, [])
      dispatch(NOTIFY_SUCCESS, {
        message: texts.NOTIFICATIONS.acceptSuccessMessage
      })
      dispatch(types.GET_PENDING_ETP_SETTLEMENTS)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    } finally {
      commit(types.SET_LOADING, false)
      commit(HIDE_CONFIRM_DIALOG)
    }
  },
  [types.CANCEL_ETP_SETTLEMENTS]: async ({ commit, dispatch }, { etpIds }) => {
    commit(types.SET_LOADING, true)

    try {
      await rejectETPSettlements(etpIds)

      commit(types.SET_SELECTED_SETTLEMENTS, [])
      dispatch(NOTIFY_SUCCESS, {
        message: texts.NOTIFICATIONS.acceptSuccessMessage
      })
      dispatch(types.GET_PENDING_ETP_SETTLEMENTS)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    } finally {
      commit(types.SET_LOADING, false)
      commit(HIDE_CONFIRM_DIALOG)
    }
  }
}
